'use client';

import { Dialog } from '@base-ui/react/dialog';
import { useRef, useState } from 'react';
import { ExitModal } from '@/features/funnel/components/ExitModal';
import { useExitModalCloseAction } from '@/features/funnel/components/ExitModal/useExitModalCloseAction';
import type { ExitIntentSignal } from './constants';
import { useDesktopMouseLeaveSignal } from './hooks/useDesktopMouseLeaveSignal';
import { useEdgeSwipeSignal } from './hooks/useEdgeSwipeSignal';
import { useIdleSignal } from './hooks/useIdleSignal';
import { useScrollBounceSignal } from './hooks/useScrollBounceSignal';
import { useVisibilityReturnSignal } from './hooks/useVisibilityReturnSignal';
import { createExitIntentTrigger, type ExitIntentTrigger } from './utils/session';
export function ExitIntentModal() {
  const [signal, setSignal] = useState<ExitIntentSignal | null>(null);
  const [hasFired, setHasFired] = useState(false);
  const spentRef = useRef(false);
  const triggerRef = useRef<ExitIntentTrigger | undefined>(undefined);
  triggerRef.current = createExitIntentTrigger({
    spentRef,
    onFire: firedSignal => {
      setSignal(firedSignal);
      setHasFired(true);
    }
  });
  useDesktopMouseLeaveSignal(triggerRef, hasFired);
  useIdleSignal(triggerRef, hasFired);
  useScrollBounceSignal(triggerRef, hasFired);
  useEdgeSwipeSignal(triggerRef, hasFired);
  useVisibilityReturnSignal(triggerRef, hasFired);
  const {
    featureViewedActivityId,
    fireCloseAction
  } = useExitModalCloseAction();
  if (!signal) return null;
  return <Dialog.Root open modal="trap-focus" onOpenChange={isOpen => {
    if (isOpen) return;
    fireCloseAction();
    setSignal(null);
  }}>
      <ExitModal featureViewedActivityId={featureViewedActivityId} />
    </Dialog.Root>;
}